<template>
    <div class="fix">
        <div class="commodity-detail l">
            <div class="detail-hd fix">
                <div id="picBanner" class="pic-box swiper-container l">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="(item, index) in product.Pictures" :key="index">
                            <img :src="item" :alt="product.Name">
                        </div>
                    </div>
                    <div class="pagination" v-if="picAmount > 1"></div>
                </div>
                <div class="text-box r">
                    <h3>{{product.Name}}</h3>
                    <div class="pro-introduce" v-html="product.FullDescription">
                        <!--<p>品牌：</p>
                        <p>产地：</p>
                        <p>型号：</p>
                        <p>颜色：</p>
                        <p>规格：</p>
                        <p>材质：</p>-->
                    </div>
                    <div class="ope-box">
                        <div class="price-wrap fix">
                            <div class="price-new l"><i class="cur">{{product.Price}}</i>积分</div>
                            <div class="price-old l" v-if="product.OldPrice">{{product.OldPrice}}积分</div>
                            <div class="recommend-tips" @click="showRecommendLayer" v-if="bntText==='积分不足'">
                                <a>赚更多积分</a>
                            </div>
                        </div>
                        <div v-if="product.IsPurchaseLimit" class="purchaseLimitCount">限购数量：{{product.PurchaseLimitCount}}</div>
                        <div class="bot-btn">
                            <a :class="`btn-item btn-exchange ${isDisabled}`" @click="checkExchangeStatus" href="javascript: void(0)">{{bntText}}</a>
                        </div>
                    </div>
                </div>
                <div class="pro-tip" v-if="tags">
                    <span class="hvc" :style="`background-color: #${ tags.BackgroundColor }; color: #${ tags.FontColor }`">{{ tags.Name }}</span>
                </div>
            </div>
            <div class="detail-bd">
                <div class="detail-text">
                    <p class="item-title"><span>兑换说明</span></p>
                    <p class="show-item" v-html="product.ExchangeExplain"></p>
                </div>
            </div>
        </div>
        <ShopRecV class="r" :rec="shopRec" @on-refresh="refreshPage">
            <h3 slot="titleText">爆款推荐</h3>
        </ShopRecV>
        <Loading :loading="loading"></Loading>
        <FillLayer :isShow="isShowFillLayer" @on-select="selectData" @on-close="closeFillLayer" @on-submit="submitInfo">
            <input class="form-item item-name" type="text" v-model="userName" slot="userName" placeholder="收件人">
            <input class="form-item item-tel" type="text" v-model="userTel" slot="userTel" placeholder="手机号码">
            <input class="form-item item-district" type="text" v-model="userDis" slot="userDistrict" placeholder="所在地区" readonly>
            <input class="form-item item-address" type="text" v-model="userAdd" slot="userAddress" placeholder="详细地址">
        </FillLayer>
        <FillNum :isShow="isShowFillNum" @on-close="closeFillNum" @on-submit="submitNum">
            <input class="form-item item-num" type="text" v-model="accountNum" slot="accountNum" placeholder="请填写会员本人的手机号" v-if="product.VirtualProductType !== 70">
            <input class="form-item item-num" type="text" v-model="accountNum" slot="accountNum" placeholder="请填写需要充值的油卡账号" v-else>
        </FillNum>
        <Message :type="messageType" :isShow="isShowMessage" :tip="messageTip" @on-close="closeMessage" @on-result="showResult">
            <a class="btn-item btn-confirm" href="javascript: void(0)" slot="confirmBtn" @click="confirmSubmit">确认兑换</a>
        </Message>
        <TipToast v-if="showRedeemTip"  content="您已兑换相同礼品，是否选择继续兑换？"  @confirm="confirmRedeem" @cancel="closeRedeemTip"></TipToast>
    </div>
</template>

<script>
    import axios from '@/libs/api.request'
    import 'swiper/css/swiper.css'
    import Swiper from 'swiper'
    import { checkTel, combineObject, delayDev, fuelCardVerify} from "@/libs/tools"
    import ShopRecV from '@/components/shop-rec-v'
    import Loading from '@/components/loading'
    import Message from '@/components/message'
    import FillLayer from '@/components/fill-info'
    import FillNum from '@/components/fill-num'
    import TipToast from '@/components/tipToast/tipToast'
    
    export default {
        name: 'commodityDetail',
        components: {
            ShopRecV,
            Loading,
            Message,
            FillLayer,
            FillNum,
            TipToast
        },
        inject: ['reload'],
        data: () => {
            return {
                picSwiper: null,
                product: {},
                tags: [],
                userPoint: 0,
                bntText: '立即兑换',
                isDisabled: '',
                shopRec: [],
                loading: false,
                isShowFillLayer: false,
                userName: '',
                userTel: '',
                userDis: '',
                userAdd: '',
                userProvince: '',
                userCity: '',
                userDistrictCounty: '',
                isShowMessage: false,
                messageType: '', // success || examine || confirm || error
                messageTip: '',
                isShowFillNum: false,
                accountNum: '',
                picAmount: 0,
                isLoop: false,
                showRedeemTip: false,
                isConfirmRedeemAgain: false,
            }
        },
        mounted () {
            this.loading = true

            this.getDetailById(this.$route.query.Id)
                .then(res => {
                    // 检测库存
                    if (res.StockQuantity === 0) {
                        this.isDisabled = 'disabled'
                        this.isShowMessage = true
                        this.messageType = 'error'
                        this.messageTip = '抱歉，库存不足！'
                    }

                    this.product = res
                    this.tags = this.product.GiftTags[0]
                    this.picAmount = this.product.Pictures.length
                    this.isLoop = this.picAmount > 1

                    // 加载pro-banner
                    delayDev(300, () => {
                        this.picSwiper = new Swiper('#picBanner', {
                            loop: this.isLoop,
                            slidesPerView: 'auto',
                            pagination: {
                                el: '.pagination',
                                type: 'bullets',
                                bulletElement: 'span',
                                clickable: true
                            },
                            autoplay: {
                                delay: 5000,
                                disableOnInteraction: false
                            }
                        })
                    })
                    if(res.IsPurchaseLimit && res.AvailableExchangeQuantity===0){
                      this.isDisabled = 'disabled'
                    }
                    // 加载积分
                    return this.getUserPoint()
                })
                .then(res => {
                    this.userPoint = res.userPoint

                    if (this.userPoint < this.product.Price) {
                        this.bntText = '积分不足'
                        this.isDisabled = 'disabled'
                    }
                })
            this.getVipRecommend()
                .then(res => {
                    this.shopRec = res.rows

                    this.loading = false

                    /**
                     * @description 滚动到页面顶部
                     * */
                    window.scrollTo({
                        top: 0
                    })
                })
            this.getCustomerAddress()
                .then(res => {
                    this.userName = res.Name ? res.Name : ''
                    this.userTel = res.Mob ? res.Mob : ''
                    this.userAdd = res.Address ? res.Address : ''

                    this.userProvince = res.Province ? res.Province : ''
                    this.userCity = res.City ? res.City : ''
                    this.userDistrictCounty = res.DistrictCounty ? res.DistrictCounty : ''
                    this.userDis = this.userProvince ? ` ${this.userCity}` : ''
                })
            window.addEventListener('popstate', this.reload, false)
        },
        beforeDestroy () {
            window.removeEventListener('popstate', this.reload, false)
        },
        methods: {
            goNext () {
                let giftType = this.product.GiftType
                let virtualProductType = this.product.VirtualProductType
                if (giftType === 10) {
                    if (virtualProductType === 50 || virtualProductType === 30) {
                        this.isShowMessage = true
                        this.messageType = 'confirm'
                        this.messageTip = '是否兑换该商品'
                    } else {
                        this.isShowFillNum = true
                    }
                }
                if (giftType === 20) {
                    this.isShowFillLayer = true
                }
                if (giftType === 30) {
                    this.isShowMessage = true
                    this.messageType = 'confirm'
                    this.messageTip = '是否兑换该商品'
                }

                try {
                    window.gio('track', 'RedeemGift', {'GiftID': this.product.Id});
                } catch (e) {
                    //console.log(e);
                }

            },
            closeFillNum() {
                this.isConfirmRedeemAgain = false
                this.isShowFillNum = false
            },
            closeFillLayer() {
                this.isConfirmRedeemAgain = false
                this.isShowFillLayer = false
            },
            submitInfo () {
                if (this.userName === '') {
                    this.messageType = 'error'
                    this.messageTip = '出错啦<br>未填写收件人姓名'
                    this.isShowMessage = true
                    return false
                }
                if (this.userTel === '') {
                    this.messageType = 'error'
                    this.messageTip = '出错啦<br>未填写收件人手机号码'
                    this.isShowMessage = true
                    return false
                }
                if (!checkTel(this.userTel)) {
                    this.messageType = 'error'
                    this.messageTip = '出错啦<br>收件人手机号码有误'
                    this.isShowMessage = true
                    return false
                }
                if (this.userDis === '') {
                    this.messageType = 'error'
                    this.messageTip = '出错啦<br>未选择所在地区'
                    this.isShowMessage = true
                    return false
                }
                if (this.userAdd === '') {
                    this.messageType = 'error'
                    this.messageTip = '出错啦<br>未填写详细地址'
                    this.isShowMessage = true
                    return false
                }
                if (this.checkAddress(this.userAdd)) {
                    this.messageType = 'error'
                    this.messageTip = '出错啦<br>请填写正确的地址信息'
                    this.isShowMessage = true
                    return false
                }
                let data = {
                    name: this.userName,
                    mob: this.userTel,
                    province: this.userProvince,
                    city: this.userCity,
                    districtCounty: this.userDistrictCounty,
                    address: this.userAdd,
                    zipCode: ''
                }

                try {
                    window.gio('track', 'RedeemSubmit', {'GiftID':this.product.Id});
                } catch (error) {
                    //console.log(error);
                }

                // 显示loading
                this.loading = true
                this.placeOrder(combineObject(data, {productId: this.product.Id}))
                    .then(res => {
                        if (res.errCode === 0) {
                            this.messageType = 'success'
                            this.messageTip = '兑换成功<br>礼品将会尽快发出！'
                            this.isShowMessage = true
                        } else {
                            this.messageType = 'examine'
                            this.messageTip = '待审核<br>审核结果请于7天后查看'
                            this.isShowMessage = true
                        }
                    })
            },
            submitNum () {
                if (this.accountNum === '' && this.product.VirtualProductType !== 50) {
                    this.messageType = 'error'
                    this.messageTip = `出错啦<br>未填写需要充值的${this.product.VirtualProductType ===70 ? '油卡账号' :'手机号'}`
                    this.isShowMessage = true
                    return false
                }
                if (!checkTel(this.accountNum) && (this.product.VirtualProductType === 10 ||
                    this.product.VirtualProductType === 20 || this.product.VirtualProductType === 40)) {
                    this.messageType = 'error'
                    this.messageTip = '出错啦<br>填写手机号不正确'
                    this.isShowMessage = true
                    return false
                }
                if(!fuelCardVerify(this.accountNum) && this.product.VirtualProductType === 70){
                  this.messageType = 'error'
                  this.messageTip = '出错啦<br>填写油卡账号不正确'
                  this.isShowMessage = true
                  return false
                }
                //显示loading
                this.loading = true
                this.placeOrder({
                    productId: this.product.Id,
                    accountnum: this.accountNum
                })
                    .then(res => {
                        if (res.errCode === 0) {
                            this.messageType = 'success'
                            this.messageTip = '兑换成功<br>请在48小时内查收短信通知'
                            this.isShowMessage = true
                        } else {
                            this.messageType = 'examine'
                            this.messageTip = '待审核<br>审核结果请于7天后查看'
                            this.isShowMessage = true
                        }
                    })
            },
            confirmSubmit () {
                this.loading = true
                this.placeOrder({
                    productId: this.product.Id
                })
                    .then(res => {
                        if (res.errCode === 0) {
                            this.messageType = 'success'
                            this.messageTip = '兑换成功<br>请至官网个人中心查看'
                            this.isShowMessage = true
                        } else {
                            this.messageType = 'examine'
                            this.messageTip = '待审核<br>审核结果请于7天后查看'
                            this.isShowMessage = true
                        }

                    })
            },
            refreshPage (id) {
                this.$router.push(`/commodity/detail?Id=${id}`)
                this.reload()
            },
            closeMessage() {
                this.isConfirmRedeemAgain = false
                this.isShowMessage = false
            },
            showResult () {
                this.$router.push('/member/shop/gift')
            },
            selectData (data) {
                this.userProvince = data.province
                this.userCity = data.city
                this.userDistrictCounty = data.district ? data.district : ''
                this.userDis = `${this.userProvince} ${this.userCity} ${this.userDistrictCounty}`
            },
            checkAddress (address) {
                let reg = /^[0-9a-zA-Z]+$/
                return reg.test(address)
            },
            getUserPoint () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserPoint',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getDetailById (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMProduct/GetDetailByIdAvailable',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            Id,
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getVipRecommend () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMProduct/GetVipRecommend',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getCustomerAddress () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMCommon/GetCustomerAddress',
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        params: {
                            v: (new Date()).getTime()
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            placeOrder (data) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/pro/Store/CMOrder/PlaceOrder',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            ...data,
                            confirm: this.isConfirmRedeemAgain
                        }
                    })
                        .then(res => {
                            this.isShowFillLayer = false
                            this.isShowFillNum = false
                            this.loading = false
                            let _data = res.data
                            if (_data.errCode === 0 || _data.errCode === 10) {
                                resolve(_data)
                            } else if (_data.errCode === 1000 || _data.errCode === 1100) {
                                window.console.log(_data.errMsg)
                                this.messageType = 'error'
                                this.messageTip = '出错啦<br>系统开小差了，晚点再回来看看吧！'
                                this.isShowMessage = true
                            } else {
                                this.messageType = 'error'
                                this.messageTip = _data.errMsg
                                this.isShowMessage = true
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            showRecommendLayer () {
                this.$store.commit('showRecommendLayer', true)
            },
            confirmRedeem() {
                this.showRedeemTip = false
                this.isConfirmRedeemAgain = true
                this.goNext()
            },
            closeRedeemTip() {
                this.showRedeemTip = false
                this.isConfirmRedeemAgain = false
            },
            /**
             * 兑换礼品-检查兑换状态
             * @returns   
             返回true：弹出提示 已兑换相同礼品，是否选择继续兑换？
             返回false：不提示
            */
            async checkExchangeStatus() {
                this.loading = true
                const  res  = await axios.request({
                        url: '/pro/Store/CMOrder/CheckExchangeStatus',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            productId: this.product.Id
                        }
                })
                this.loading = false
                // 0 ：成功，可以兑换。2000：您已兑换相同礼品，是否选择继续兑换？
                // 1010： 礼品不存在 1020： 用户积分不足
                if (res.data.errCode === 2000) {
                     this.showRedeemTip = true
                } else {
                   this.isConfirmRedeemAgain = false
                    this.goNext()
                }
            }
            
        }
    }
</script>

<style lang="less" scoped>
    .commodity-detail{
        width: 950px;
        padding: 20px;
        background-color: #fff;
        border: #d4dbde solid 1px;
        box-shadow: 0 0 24px rgba(146,148,154,0.13);
        -webkit-box-shadow: 0 0 24px rgba(146,148,154,0.13);
        -moz-box-shadow: 0 0 24px rgba(146,148,154,0.13);
        -o-box-shadow: 0 0 24px rgba(146,148,154,0.13);
        .detail-hd{
            position: relative;
            padding-bottom: 29px;
            border-bottom: #d4dbde solid 1px;
            .pic-box{
                width: 520px;
                height: 333px;
                .swiper-slide{
                    height: 333px;
                    overflow: hidden;
                    img{
                        width: 100%;
                    }
                }
                .pagination{
                    position: absolute;
                    left: 0;
                    bottom: 10px;
                    z-index: 9;
                    width: 100%;
                    height: 14px;
                    text-align: center;
                    .swiper-pagination-bullet{
                        width: 14px;
                        height: 14px;
                        background: #d4dbde;
                    }
                    .swiper-pagination-bullet-active{
                        background: #fbc500;
                    }
                }
            }
            .text-box{
                position: relative;
                width: 368px;
                height: 333px;
                h3{
                    font-size: 20px;
                    line-height: 36px;
                }
                .pro-introduce{
                    padding-top: 8px;
                    line-height: 24px;
                    color: #747d80;
                }
                .ope-box{
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    .price-wrap{
                        height: 30px;
                        margin-bottom: 14px;
                        .price-new{
                            font-size: 20px;
                            color: #ffa70d;
                            line-height: 30px;
                            .cur{
                                position: relative;
                                top: 3px;
                                margin-right: 4px;
                                font-size: 36px;
                                font-weight: bold;
                            }
                        }
                        .price-old{
                            padding-top: 16px;
                            margin-left: 13px;
                            color: #747d80;
                            line-height: 1;
                            text-decoration: line-through;
                        }
                        .recommend-tips {
                            display: inline-block;
                            margin-left: 20px;
                            vertical-align: bottom;
                            padding-top: 12px;
                            a {
                                color: #006bad;
                                cursor: pointer;
                                &:hover {
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                    .purchaseLimitCount{
                      color: #747d80;
                      margin-bottom: 8px;
                    }
                    .bot-btn{
                        .btn-exchange{
                            width: 340px;
                            height: 44px;
                            background-color: #fbc500;
                            font-size: 16px;
                            line-height: 44px;
                            text-align: center;
                            &.disabled{
                                background-color: #eaeaeb;
                                color: #747d80;
                                pointer-events: none;
                            }
                        }
                    }
                }
            }
            .pro-tip{
                position: absolute;
                left: 0;
                top: 0;
                z-index: 9;
                span{
                    width: 97px;
                    height: 38px;
                    border-bottom-right-radius: 12px;
                    color: #fff;
                    font-size: 16px;
                    text-align: center;
                    line-height: 38px;
                }
            }
        }
        .detail-bd{
            padding-top: 18px;
            .show-item{
                padding-top: 14px;
            }
        }
    }
</style>
